import React from 'react'
import Button from './../../../Components/common/Button'
import SearchItems from './../../../Components/Devices/searchItems'
import Grid from '@mui/material/Grid'
import DateRangePicker from './../../../Components/common/DateRangePicker'
import Scrollbar from 'react-scrollbars-custom'
import Checkbox from '../../../Components/common/Checkbox'
import { FormHelperText } from '@mui/material'
import DeviceAttributeSelector from '../../../Components/Message/DeviceAttributesSelector'
import { checkPrivileges } from '../../../Helpers'


const MessagesSidebar = (props) => {
  const { selectedForm, handleSelectForm } = props
  const createMessagesReports = (type) => {
    props.collapseSidebar()
    props.createMessagesReport(1, type)
  }
  const baseAttributes = props.selectedDeviceAttributes?.attributes;

  const deviceAttributesObject = baseAttributes
    ? {
      ...baseAttributes,
      ...(baseAttributes.speed === undefined && { speed: 0 }),
    }
    : {};
   function getDeviceAttributeOptions(deviceAttributesObject) {
  const options = [];
  Object.entries(deviceAttributesObject ?? {})
    .filter(([key]) => key !== 'unknown' && key !== 'MC' && key !== 'driverUniqueId')
    .forEach(([key]) => {
      options.push({ key, value: key });

      if (key?.toLowerCase().includes("fuel")) {
        const medianKey = `${key}Median`;
        const medianValue = `${key} Median`;

        options.push({ key: medianKey, value: medianValue });
      }
    });
  return options.sort((a, b) => a.value.localeCompare(b.value));
}

const deviceAttributesOptions =getDeviceAttributeOptions(deviceAttributesObject)



  let viewScreen = (
    <>
    {checkPrivileges('positionGraph') && (
      <>
        <Button
          onClick={() => handleSelectForm("dlogsForm")}
          style={{
            backgroundColor: selectedForm === "dlogsForm" ?
              props.themecolors.menuBackgroundColor :
              props.themecolors.menuActiveBackground,
            color: selectedForm === "dlogsForm"
              ? (props.themecolors?.id === 4
                ? props.themecolors.menuTextColor
                : "white")
              : props.themecolors.menuActiveColor,

            width: "50%",
          }}
        >
          {props.translate('dlogsForm')}
        </Button>
        <Button
          onClick={() => handleSelectForm("graphForm")}
          style={{
            backgroundColor: selectedForm === "graphForm" ?
              props.themecolors.menuBackgroundColor :
              props.themecolors.menuActiveBackground,
            color: selectedForm === "graphForm"
              ? (props.themecolors?.id === 4
                ? props.themecolors.menuTextColor
                : "white")
              : props.themecolors.menuActiveColor,
            width: "50%",
          }}
        >
          {props.translate('graphForm')}
        </Button>
      </>
    )}
      {selectedForm === "dlogsForm" ?
        <>
          <form style={{ padding: 20 }}>
            <h3 className='page-title'>{props.translate('DlogsForm')}</h3>
            <Grid container>
              <Grid item xs={12}>
                <DateRangePicker
                  fill
                  selectedDate={props.selectedDate}
                  label={
                    props.translate('reportFrom') +
                    ' ' +
                    props.translate('reportTo')
                  }
                  onEvent={props.selectDate}
                  dlogs
                  isDisabled={(date) => moment().diff(date, 'days', true) <= 0 || moment().diff(date, 'days', true) >= 3}
                />
                <FormHelperText
                  style={{ fontWeight: "bold", color: "#ffc107", fontSize: "12px" }} // Changed fontWeight and color
                >
                  {props.translate(`You can select maximum 3 days`)}
                </FormHelperText>
              </Grid>

              <Grid item xs={12} style={{ padding: '0 0 8px' }}>
                <SearchItems
                  api='devices'
                  fill
                  isMulti={false}
                  onChange={props.selectDevice}
                  value={
                    props.selectedDevice && props.selectedDevice.label
                      ? props.selectedDevice
                      : null
                  }
                  placeholder={props.translate('selectedTrackers')}
                />
              </Grid>
              <Grid item xs={12} style={{ padding: '0 0 8px' }}>
                <Checkbox
                  checked={props.detail && props.detail}
                  onChange={e => props.changeDetail('detail', e)}
                  canAssign
                  canRemove
                />
                <span style={{ marginLeft: '8px' }}>
                  {props.translate('detail')}
                </span>
              </Grid>
              <Grid item xs={12} style={{ padding: '0 0 8px' }}>
                <Button
                  fullWidth
                  disabled={!props.validatedForm}
                  onClick={createMessagesReports}
                >
                  {props.translate('submit')}
                </Button>
              </Grid>
              <div className='report-sidebar-switch' style={{ margin: '0 auto', marginTop: '-5px' }}></div>
              <Grid item xs={12} style={{ padding: '0 0 8px' }}>
                <Button
                  fullWidth
                  disabled={!props.validatedForm}
                  onClick={() => createMessagesReports('excel')}
                >
                  {props.translate('DOWNLOAD')}
                </Button>
              </Grid>
            </Grid>
          </form>
        </> :
        <>
          <form style={{ padding: 20 }}>
            <h3 className='page-title'>{props.translate('graphForm')}</h3>
            <Grid container>
              <Grid item xs={12}>
                <DateRangePicker
                  fill
                  selectedDate={props.selectedDateGraph}
                  label={
                    props.translate('reportFrom') +
                    ' ' +
                    props.translate('reportTo')
                  }
                  onEvent={props.graphFormDateSelect}
                  key={"dlogsForm"}
                  dlogsGraphForm
                  isDisabled={(date) => moment().diff(date, 'days', true) <= 0 || moment().diff(date, 'days', true) >= 2}
                />
                <FormHelperText
                  style={{ fontWeight: "bold", color: "#ffc107", fontSize: "12px" }}
                >
                  {props.translate(`You can select maximum 1 days`)}
                </FormHelperText>
              </Grid>

              <Grid item xs={12} style={{ padding: '0 0 8px' }}>
                <SearchItems
                  api='devices'
                  fill
                  isMulti={false}
                  onChange={props.selectDevice}
                  value={
                    props.selectedDevice && props.selectedDevice.label
                      ? props.selectedDevice
                      : null
                  }
                  placeholder={props.translate('selectedTrackers')}
                />
              </Grid>
              {
                props.selectedDevice &&
                Array.isArray(deviceAttributesOptions) &&
                deviceAttributesOptions.length > 0 && (
                  <Grid item xs={12} style={{ padding: '0 0 8px', zIndex: 0 }}>
                    <DeviceAttributeSelector
                      value={props.deviceAttributes}
                      onChange={props.setDeviceAttributes}
                      options={deviceAttributesOptions}
                      translate={props.translate}
                      classes={props.classes}
                      deviceChange={props.selectedDevice}
                    />
                  </Grid>
                )
              }

              <Grid item xs={12} style={{ padding: '0 0 8px' }}>
                <Button
                  fullWidth
                  disabled={!props.validatedGraphForm}
                  onClick={props.handleSubmitGraphForm}
                >
                  {props.translate('submit')}
                </Button>
              </Grid>
              <div className='report-sidebar-switch' style={{ margin: '0 auto', marginTop: '-5px' }}></div>
              {/* <Grid item xs={12} style={{ padding: '0 0 8px' }}>
                <Button
                  fullWidth
                  disabled={!props.validatedForm}
                  onClick={() => createMessagesReports('excel')}
                >
                  {props.translate('DOWNLOAD')}
                </Button>
              </Grid> */}
            </Grid>
          </form>
        </>
      }
    </>

  )

  if (viewScreen) {
    return (
      <aside className='fms-sidebar sidebar-bg-layer'>
        <Scrollbar>{viewScreen}</Scrollbar>
      </aside>
    )
  } else {
    return null
  }
}

export default MessagesSidebar;



